// Utility to test API connection and clear debug settings
export const clearDebugSettings = () => {
  // Clear any debug or mock mode settings
  localStorage.removeItem('verity-debug-mode');
  localStorage.removeItem('verity-use-mock');
  localStorage.removeItem('verity-sources-mock');
  localStorage.removeItem('verity-tips-mock');
  localStorage.removeItem('verity-assignments-mock');

  console.log('Cleared all debug and mock mode settings');
};

export const testApiConnection = async () => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL;
  console.log('🔗 Testing API connection to:', apiUrl);

  try {
    const response = await fetch(apiUrl + '/health', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      console.log('✅ API connection successful!', {
        url: apiUrl,
        status: response.status
      });
      return true;
    } else {
      console.log('⚠️ API responded with error:', response.status);
      return false;
    }
  } catch (error) {
    console.log('❌ API connection failed:', error);
    return false;
  }
};

// Auto-clear debug settings on import
clearDebugSettings();
